jQuery( document ).ready( function() {
  const headerHeight = jQuery( '#masthead' ).height(); // Get fixed header height

  jQuery( 'a[href*=#]:not([href=#])' ).click( function() {
    if ( location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) || location.hostname == this.hostname ) {
      let target = jQuery( this.hash );

      target = target.length ? target : jQuery( '[name=' + this.hash.slice( 1 ) + ']' );

      if ( target.length ) {
        jQuery( 'html,body' ).animate( {
          scrollTop: target.offset().top - headerHeight,
        }, 500 );
        return false;
      }
    }
  } );

  jQuery( window ).load( function() {
    if ( location.hash ) {
      let id = jQuery( location.hash );
      jQuery( 'html,body' ).animate( { scrollTop: id.offset().top - headerHeight }, 500 );
    }
  } );
} );
